var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Messages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1431.000000, -361.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messages",
    transform: "translate(1431.000000, 361.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2381",
    points: "5.4 5.4 12.6 5.4 12.6 3.6 5.4 3.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2382",
    points: "5.4 8.1 10.8 8.1 10.8 6.3 5.4 6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2383",
    points: "3.6 8.22042 3.6 1.79982 14.4 1.79982 14.4 8.22042 16.2 7.19172 16.2 -0.00018 1.8 -0.00018 1.8 7.19172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93904,11.7 L6.06114,11.7 L-0.00036,8.2368 L-0.00036,16.2 C-0.00036,17.1936 0.80604,18 1.79964,18 L16.19964,18 C17.19324,18 17.99964,17.1936 17.99964,16.2 L17.99964,8.2368 L11.93904,11.7 Z",
    id: "Fill-2384"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.75003d64fe25b72f866128238bc7bcc6.svg";
export { ForwardRef as ReactComponent };